import { render, staticRenderFns } from "./AllCommends.vue?vue&type=template&id=2c2e43a5&scoped=true"
import script from "./AllCommends.vue?vue&type=script&lang=js"
export * from "./AllCommends.vue?vue&type=script&lang=js"
import style0 from "./AllCommends.vue?vue&type=style&index=0&id=2c2e43a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e43a5",
  null
  
)

export default component.exports